module.exports = __webpack_public_path__ + "img/company-growth.d8a2e6a7.png";